import { render } from "./MyBillEs.vue?vue&type=template&id=5b25ba0a&scoped=true"
import script from "./MyBillEs.vue?vue&type=script&lang=js"
export * from "./MyBillEs.vue?vue&type=script&lang=js"

import "./MyBillEs.vue?vue&type=style&index=0&id=5b25ba0a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25ba0a"]])

export default __exports__